import React, { useContext } from 'react';
import { Step } from '../../../types';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { DataContext } from '@/context';

const steps: Step[] = [
  { num: '01', title: '成为会员', desc: '开通森宇宙好绘AI会员' },
  { num: '02', title: '报名认证', desc: '提交作品集及信息认证，入驻平台设计师库' },
  { num: '03', title: '接收派单', desc: '平台推送匹配的商单（附甲方需求、预算、交付时间）' },
  { num: '04', title: '沟通创作', desc: '在平台内与甲方沟通需求，提交初稿 -> 修改 -> 终稿' }
];

const Process: React.FC<{ childRef }> = ({ childRef }) => {
  const searchParamsString = window.location.href.split('?')[1] || '';
  const searchParams = new URLSearchParams(searchParamsString);
  searchParams.delete('y');
  const navigate = useNavigate();
  const {
    userInfo,
    setContextValue
  } = useContext(DataContext);
  return (
    <section id="tutorial" className="bg-black py-16 md:py-32 px-4 border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-center text-4xl md:text-5xl font-semibold text-white mb-10 md:mb-20">
          接单流程。<br />
          <span className="text-gray-500 text-base md:text-4xl mt-2 md:mt-4 block font-normal">4步接单，坐等收钱。</span>
        </h2>

        <div className="grid grid-cols-4 gap-2 md:gap-8 relative mb-12 md:mb-24">
          {/* Connecting Line */}
          <div className="block absolute top-6 md:top-12 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>

          {steps.map((step, index) => (
            <div key={index} className="relative flex flex-col items-center text-center group">
              <div className="w-12 h-12 md:w-24 md:h-24 rounded-full bg-[#0a0a0a] border border-white/10 flex items-center justify-center text-lg md:text-3xl font-bold text-white mb-2 md:mb-6 relative z-10 group-hover:border-blue-500 group-hover:shadow-[0_0_20px_rgba(37,99,235,0.3)] transition-all duration-300 bg-black">
                {step.num}
              </div>
              <h3 className="text-[10px] md:text-xl font-bold text-white mb-1 md:mb-3 whitespace-nowrap">{step.title}</h3>
              <p className="text-gray-400 text-[8px] md:text-base leading-tight px-0 md:px-4 hidden md:block">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="flex justify-center">
          <button className="group relative px-6 py-3 md:px-10 md:py-5 bg-white text-black rounded-full text-base md:text-xl font-bold hover:bg-gray-100 transition-all shadow-[0_0_40px_rgba(255,255,255,0.15)] flex items-center gap-2 md:gap-3"
            onClick={() => {
              if (!(userInfo?.user_id === 0 || userInfo?.user_id)) {
                childRef?.current?.openLogin?.()
                return
              }
              navigate({ pathname: '/price', search: '?' + searchParams.toString() });
              // setIsModalOpen(true)
            }}
          >
            开通会员
            <ArrowRight className="w-4 h-4 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Process;